import React from 'react';

function EPContactInstagram() {
  return (
    <div>EPContactInstagram</div>
  );
}

export default EPContactInstagram;
